import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CarregamentoService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
		private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/carregamentos';
	}

	detalhar(id: any) {
		return this.get<any>('/detalhar', {
			dados: {
				id: id
			}
		});
	}

	alterarMotoristaAjudante(dados: any) {
		return this.post('/alterarMotoristaAjudante', {
			dados: dados, enviarComoQueryString: true
		});
	}

	listarCarregamentosComRecebivel(id: any) {
		return this.get('/listar', {
			dados: {
				motorista: id,
				apenasComRecebiveis: true
			}
		});
	}

	listarCarregamentosMotorista(idMotorista: any) {
		return this.get<any[]>('/listarCarregamentosMotorista', {
			dados: {
				idMotorista: idMotorista
			}, exibirLoading: false
		});
	}

	listarCarregamentosDoMotorista(idMotorista: any) {
		return this.get<any[]>('/listarCarregamentosDoMotorista', {
			dados: {idMotorista},
		});
	}

	gerarocOrrenciasCarregamento() {
		return this.get('/relatorio/ocorrenciasCarregamento/teste');
	}

	pesquisarLimitado(id: string, idsExcluidos: [string]) {
		return this.get<any[]>('/pesquisarLimitado', {
			dados: { id, idsExcluidos },
			exibirLoading: false
		});
	}

	pesquisar(dados: any,  query: string) {
		return this.post<any>(`/pesquisar?${query}`, {
			dados
		});
	}

	buscarVisualizarCarregamentosMonitoramento(filtros: any) {
		return this.post<any>('/buscarVisualizarCarregamentosMonitoramento', {
			dados: filtros,
			exibirLoading: true
		});
	}
}
